import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-rdf-angular-core',
  template: `
    <p>
      rdf-angular-core works!
    </p>
  `,
  styles: [
  ]
})
export class RdfAngularCoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
